import type { VATRate } from '@finapp/types';
import { apiUrl, fetchWithAuth } from '../config/api';

export class VatService {
  /**
   * Get all available VAT rates
   */
  async getVatRates(): Promise<VATRate[]> {
    const response = await fetchWithAuth(apiUrl('vat/active'));
    if (!response.ok) {
      throw new Error(`Failed to fetch VAT rates: ${response.statusText}`);
    }
    return response.json();
  }

  /**
   * Get all VAT rates (including historical ones)
   */
  async getAllVatRates(): Promise<VATRate[]> {
    const response = await fetchWithAuth(apiUrl('vat/all'));
    if (!response.ok) {
      throw new Error(`Failed to fetch all VAT rates: ${response.statusText}`);
    }
    return response.json();
  }

  /**
   * Get VAT rate by ID
   */
  async getVatRateById(id: number): Promise<VATRate> {
    const response = await fetchWithAuth(apiUrl(`vat/${id}`));
    if (!response.ok) {
      throw new Error(`Failed to fetch VAT rate: ${response.statusText}`);
    }
    return response.json();
  }
}

export const vatService = new VatService();
